export const FILE_STATUS = {
  DONE: 'done',
  ERROR: 'error',
  REMOVED: 'removed',
  UPLOADING: 'uploading'
};

export const ALLOWED_IMG_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];
